<div class="routeFilter" *ngIf="true">
  <loading [isLoading]="isLoading"></loading>
  <div class="container_text" id="panelRoutes">
    <h1 class="title_routefilter" matTooltipPosition="above">Control de Rutas</h1>
    <div class="btnClose">
      <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="onClose()"></mat-icon>
    </div>
    <div class="">
      <div class="section-header-background">
      </div>
    </div>
    <form #forma="ngForm" class="route-form">
      <mat-form-field appearance="fill" class="input-90" color="accent">
        <input type="text" 
          [(ngModel)]="request.vehiculo"
          placeholder="Identificador o Contrato"
          name="vehiculo"
          minlength="5"
          required
          aria-label="Number"
          (click)="selectLocation()"
          (keyup)="onFindLocation($event)"
          matInput [formControl]="myControl" [matAutocomplete]="auto" >
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected()">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
            {{option.identifier}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <div class="raw-checkbox">
        <label class="switch">
          <mat-slide-toggle (change)="setRawRequest()"></mat-slide-toggle>
          <!-- <img *ngIf="isRawRequest" [src]="'btn_on.svg' | findUrl" class="img-button" (click)="setRawRequest()">
          <img *ngIf="!isRawRequest" [src]="'btn_off.svg' | findUrl" class="img-button" (click)="setRawRequest()"> -->
        </label>
        <span matTooltip="* Se mostrarán como máximo 3 horas posteriores a la hora seleccionada.">Modo Avanzado</span>
      </div>
      
      <div class="date-selector" *ngIf="!isRawRequest">
        <mat-form-field class="input-90" appearance="fill" color="accent">
          <mat-label>Introduce un rango de fechas</mat-label>
          <mat-date-range-input [rangePicker]="picker"  [min]="minStartDate" [max]="maxStartDate"  [disabled]="isDatePickerDisabled">
            <input [(ngModel)]="request.startDate" matStartDate placeholder="Desde" name="startDate" (dateInput)="limteFecha($event)" (click)="picker.open()">
            <input [(ngModel)]="request.endDate" matEndDate placeholder="Hasta" name="endDate" (click)="picker.open()">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"  [disabled]="isDatePickerDisabled">
            <mat-icon matDatepickerToggleIcon svgIcon="custom_calendar"></mat-icon>
          </mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
      
      <div class="date-selector" *ngIf="isRawRequest">
        <mat-form-field class="input-90" appearance="fill" color="accent">
          <mat-label>Fecha</mat-label>
          <input matInput [matDatepicker]="picker" [(ngModel)]="rawDate" name="rawDate" (dateChange)="onDateChange($event)" (click)="picker.open()" [disabled]="isDatePickerDisabled">
          <mat-datepicker-toggle matSuffix [for]="picker" ></mat-datepicker-toggle>
          <mat-datepicker #picker ></mat-datepicker>
        </mat-form-field>
        
        <mat-form-field appearance="fill" class="input-90">
          <mat-label>Hora de inicio</mat-label>
          <input
            matInput
            placeholder="Seleccionar Hora"
            [(ngModel)]="rawStartTime"
            name="startTime"
            aria-label="24hr format"
            [ngxTimepicker]="startTime"
            [format]="24"
            [disabled]="isDatePickerDisabled"
            readonly>
          <ngx-material-timepicker
            #startTime
            [hoursOnly]="false">
          </ngx-material-timepicker>
        </mat-form-field>

      </div>
      
      
      <!-- <mat-slide-toggle
        class="item_routeFilter"
        [checked]="checkedDia"
        (change)="ngOnSelectTime()"
      >
        Todo el dia </mat-slide-toggle
      ><br /> -->
     
      <!-- <input type="checkbox" value="Seleccionar Horas" (change)="ngOnSelectTime()"> -->
      <div class="divFechas" *ngIf="isSelectTime">
        <label class="item_routeFilter">Hora Inicio</label><br />
        <div class="24hr-example">
          <input
            placeholder="Seleccionar"
            [(ngModel)]="request.startTime"
            name="startTime"
            aria-label="24hr format"
            [ngxTimepicker]="startTime"
            [format]="24"
            readonly
          />
          <ngx-material-timepicker
            #startTime
            [hoursOnly]="true"
          ></ngx-material-timepicker>
        </div>

        <label class="item_routeFilter">Hora Final</label><br />
        <div class="24hr-example">
          <input
            placeholder="Seleccionar"
            name="endTime"
            [(ngModel)]="request.endTime"
            aria-label="12hr format"
            [ngxTimepicker]="endTime"
            [format]="24"
            readonly
          />
          <ngx-material-timepicker
            #endTime
            [hoursOnly]="true"
          ></ngx-material-timepicker>
        </div>
       
      </div>

     

      <div class="row">
      <button mat-fab extended class="btnBuscar form-control" (click)="onSubmit()" [disabled]="isDatePickerDisabled">
        Buscar <mat-icon>search</mat-icon>
      </button>
    </div>
    </form>
  </div>

  <div class="">
    <div class="section-footer-background">
    </div>
  </div>
</div>